// extracted by mini-css-extract-plugin
export default {"container":"IH","promoapplied":"JH","tobeapplied":"KH","hr":"LH","teal":"MH","promoappliedcontainer":"NH","error":"OH","input":"PH","errorInput":"QH","promo_x":"RH","promo_info":"SH","promoxcontainer":"TH"};
    if(module.hot) {
      // 1713996747750
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  